export default class Member
{
  constructor(roles, descriptions, name, photo, position) 
  {
    // {} instead of array to support stringify
    this.roles = roles;
    this.descriptions = descriptions;

    this.name = name;
    this.photo = photo;
    this.position = position;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.roles)) { if(!value) { result = false; break; }; } // Roles
    if(result) for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; }; } // Descriptions

    if(result) result = this.name && this.photo;
    
    return result;
  }
}